var _line, _line2, _line3, _ellipse, _ellipse2, _ellipse3, _ellipse4, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportEv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -0.3125,
    x2: 8.60738,
    y2: -0.3125,
    transform: "matrix(0.928906 0.370315 -0.39963 0.916677 15.9461 24.875)",
    stroke: "#005760",
    strokeWidth: 0.625
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -0.3125,
    x2: 9.22391,
    y2: -0.3125,
    transform: "matrix(0.722734 -0.691126 0.722734 0.691126 28.9396 27)",
    stroke: "#005760",
    strokeWidth: 0.625
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: -0.3125,
    x2: 10.9383,
    y2: -0.3125,
    transform: "matrix(0.812612 -0.582805 0.617133 0.786859 38.1663 20.6245)",
    stroke: "#005760",
    strokeWidth: 0.625
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.8332,
    cy: 23.812,
    rx: 3.33322,
    ry: 3.18744,
    fill: "#00D084"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.9431,
    cy: 28.0624,
    rx: 3.33322,
    ry: 3.18744,
    fill: "#00D084"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.0531,
    cy: 19.5634,
    rx: 3.33322,
    ry: 3.18744,
    fill: "#00D084"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.1667,
    cy: 13.1874,
    rx: 3.33322,
    ry: 3.18744,
    fill: "#00D084"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 33.3745,
    width: 6.66643,
    height: 19.1247,
    fill: "#00D084"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22.6099,
    y: 37.6245,
    width: 6.66643,
    height: 14.8747,
    fill: "#797D8D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 33.7198,
    y: 31.2505,
    width: 6.66643,
    height: 21.2496,
    fill: "#001574"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 44.8334,
    y: 24.875,
    width: 6.66643,
    height: 27.6245,
    fill: "#4585FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportEv);
export default __webpack_public_path__ + "static/media/reportEv.b5d1d8b53ff7b22c8a81cbc31619f2fc.svg";
export { ForwardRef as ReactComponent };